const SALES_ORDER = 'salesOrder';
const FULFILLMENT_PLAN = 'fulfillmentPlan';
const BATCH_DETAILS = 'batchDetails';
const BATCH_DETAILS_FULL = 'batchDetailsFull';
const ORDERS_SHIPMENT_MODE_BATCH_DETAILS_FULL = 'ordersShipmentModeBatchDetailsFull';

export const BulkActionDataType = {
  SALES_ORDER,
  FULFILLMENT_PLAN,
  BATCH_DETAILS,
  BATCH_DETAILS_FULL,
  ORDERS_SHIPMENT_MODE_BATCH_DETAILS_FULL,
};
